import { render, staticRenderFns } from "./CompanyCardVerB.vue?vue&type=template&id=5c36092c&scoped=true"
import script from "./CompanyCardVerB.vue?vue&type=script&lang=ts"
export * from "./CompanyCardVerB.vue?vue&type=script&lang=ts"
import style0 from "./CompanyCardVerB.vue?vue&type=style&index=0&id=5c36092c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36092c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c36092c')) {
      api.createRecord('5c36092c', component.options)
    } else {
      api.reload('5c36092c', component.options)
    }
    module.hot.accept("./CompanyCardVerB.vue?vue&type=template&id=5c36092c&scoped=true", function () {
      api.rerender('5c36092c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/CompanyCardVerB.vue"
export default component.exports